import React from "react";
import AlertsPanel from "./AlertsPanel";
import TodoListPanel from "./TodoListPanel";

const RightSidebar = () => {
  return (
    <div className="w-80 bg-gray-50 dark:bg-gray-800 border-l border-gray-200 dark:border-gray-700 h-full overflow-y-auto">
      {/* Alerts Panel */}
      <AlertsPanel />

      {/* Todo List Panel */}
      <TodoListPanel />
    </div>
  );
};

export default RightSidebar;
